module.exports = __webpack_public_path__ + "static/media/pokemon.96383a23.jpg";